var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1155 7.03096C17.6021 7.03096 17.9966 6.63653 17.9966 6.14993V1.68398C17.9966 1.19737 17.6021 0.802948 17.1155 0.802948H0.125V17.4919H17.1155C17.6021 17.4919 17.9966 17.0975 17.9966 16.6109V12.1449C17.9966 11.6582 17.6021 11.2638 17.1155 11.2638C15.9485 11.2638 14.9991 10.3145 14.9991 9.14742C14.9991 7.98038 15.9485 7.03096 17.1155 7.03096V7.03096Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.ecc18b416dc76ce1ccff4d6896720faa.svg";
export { ForwardRef as ReactComponent };